"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("./styles/withStyles");

var createStyles_1 = require("./styles/createStyles");

var colorManipulator_1 = require("./styles/util/colorManipulator");

var util_1 = require("./styles/util");

var styles = function styles(_ref) {
  var palette = _ref.palette;
  return createStyles_1.createStyles({
    grouped: {
      color: palette.primary.main,
      backgroundColor: palette.background.paper,
      borderColor: colorManipulator_1.fade(palette.primary.main, 0.5),
      '&:hover': {
        backgroundColor: colorManipulator_1.fade(palette.primary.main, 0.08),
        borderColor: palette.primary.main
      },
      '&:focus': {
        boxShadow: 'none'
      },
      '&.UnifiButtonGroup-active': {
        color: palette.primary.contrastText,
        backgroundColor: palette.primary.main,
        transition: 'none',
        '&:hover': {
          borderColor: palette.primary.main
        }
      }
    },
    groupedOutlined: {
      '&:not(:first-child)': {
        borderLeftColor: colorManipulator_1.fade(palette.primary.main, 0.5)
      },
      '&:hover': {
        zIndex: 1
      }
    },
    root: {},
    fullWidth: {},
    groupedOutlinedPrimary: {},
    groupedOutlinedSecondary: {}
  });
};

var ButtonGroup = function ButtonGroup(_a) {
  var children = _a.children,
      className = _a.className,
      classes = _a.classes,
      margin = _a.margin,
      padding = _a.padding,
      props = __rest(_a, ["children", "className", "classes", "margin", "padding"]);

  var buttonArray = React.Children.toArray(children);
  var activeIndex = buttonArray.findIndex(function (button) {
    return button.props.active;
  });

  var _React$useState = React.useState(activeIndex),
      activeButton = _React$useState[0],
      setActiveButton = _React$useState[1];

  var rootClasses = clsx_1.default(className, util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }));
  var buttons = buttonArray.map(function (button, index) {
    var isActive = typeof activeButton === 'number' && index === activeButton;
    var controlProps = {
      setActiveButton: setActiveButton,
      'aria-pressed': isActive ? 'true' : 'false'
    };
    var state = {
      index: index,
      isActive: isActive
    };
    return [React.cloneElement(button, Object.assign(Object.assign(Object.assign({}, controlProps), state), button.props))];
  });
  return React.createElement(ButtonGroup_1.default, Object.assign({}, props, {
    classes: classes,
    className: rootClasses
  }), buttons);
};

exports.default = withStyles_1.withStyles(styles)(ButtonGroup);